import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles<{ isOpen: boolean }>()((theme, { isOpen }) => ({
	price: {
		width: 'auto',
		cursor: 'pointer',
	},
	drawer: {
		[getFromBreakpoint('lg')]: {
			top: theme.navbar.height,
			zIndex: theme.zIndex.lifted,
		},
	},
	priceDrawerBar: {
		background: theme.palette.neutral[0],
		boxSizing: 'border-box',
		position: 'fixed',
		height: theme.navbar.height,
		maxHeight: theme.navbar.height,
		/** Use lower z index on mobile because of the sticky navigation */
		zIndex: theme.zIndex.lifted,
		bottom: 0,
		/** Remove the padding from width from to keep consistent container  */
		width: `calc('100vw' - (2 * ${theme.spacing.small}))`,
		padding: `${theme.spacing.xsmall} ${theme.spacing.small}`,
		boxShadow: isOpen ? 'unset' : theme.elevation.down.raised,
		left: 0,
		right: 0,
		display: 'flex',
		alignItems: 'center',

		[getFromBreakpoint('lg')]: {
			zIndex: theme.zIndex.floating,
			boxShadow: isOpen ? 'unset' : theme.elevation.top.raised,
			bottom: 'auto',
			top: 0,
			display: 'grid',
		},
	},
	accommodationTitle: {
		margin: 0,
		textWrap: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},

	priceDrawerBarContent: {
		maxWidth: theme.container.width.lg,
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		boxSizing: 'border-box',

		[getFromBreakpoint('lg')]: {
			display: 'grid',
			alignItems: 'center',
			gridTemplateColumns: '1fr auto 1fr',
			gap: theme.spacing.xxlarge,
			marginRight: 'auto',
			marginLeft: 'auto',
		},
	},
	priceToggle: {
		display: 'flex',
		flexDirection: 'row',
		gap: theme.spacing.xsmall,
		justifyContent: 'flex-end',
	},
	buttonContainer: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		gap: theme.spacing.xxsmall,
	},
	dealTag: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	priceContainer: {
		display: 'flex',
		gap: theme.spacing.xxsmall,
	},
}));
